// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  NewsFeed State
// -------------------------------
export interface NewsFeedState extends EntityState<any> {
  common?: any;
  newsfeedEmployeeLookup: Array<any>;
  newsfeedGroupLookup: Array<any>;
  newsfeedClientLocationLookup: Array<any>;
}

// -------------------------------
//  NewsFeed Adapter
// -------------------------------
export const newsFeedAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  NewsFeed Initial State
// -------------------------------
export const initialState: NewsFeedState = newsFeedAdapter.getInitialState(
  {
    common: null,
    newsfeedEmployeeLookup: [],
    newsfeedClientLocationLookup: [],
    newsfeedGroupLookup:[] ,
  },
);
